import VerificationMethodDisplay from './VerificationMethodDisplay';

export default VerificationMethodDisplay;
